import log from "../log.svg";
import "../Navbar.css";

const Navbar = () => {
  return (
    <div className="navbar-wrapper">
      <nav className="navbar">
        <div className="navbar-left">
          <img src={log} alt="Logo" className="navbar-logo" />
          <strong style={{ paddingLeft: 20 }}>Log-Stock</strong>
        </div>
      </nav >
    </div >
  )
};

export default Navbar;
